import React, { useRef, useState, useEffect, useReducer } from "react";
import ReactToPrint from "react-to-print";
import styled, { css } from "react-emotion";
import { Form, FlexRow, FlexColumn, Button } from "appStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "@material-ui/core/Modal";
import NumberFormat from "react-number-format";
import { TextArea } from "components";
import { priceToDollars } from "helpers";
import { find } from "lodash";

const TextAreaStyle = css`
  margin-top: 20px;
  resize: none;
  /* min-height: 7rem; */
  background: none;
  color: #1f3747;
  outline: none;
  box-shadow: none;
  height: 5rem;
  border: 1px solid #979797;
  padding: 6px 10px;
  transition: 0.4s;
  width: 100%;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  position: relative;
  border-radius: 5px;
  margin-bottom: 3em;
`;
const formStyle = css`
  position: relative;
  padding: 20px;
  background: white;
  border-radius: 0px 0px 5px 5px;
`;

const inputStyle = css`
  width: 100%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

const listStyleItems = css`
  padding-left: 0;
  list-style-type: "- ";
  list-style-position: inside;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-weight: "normal";
  font-size: 14px;
  color: "black";
  margin: "10px";
  @media only screen and (min-width: 768px) {
    text-align: left;
  }
`;

const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;

const boldButton = css`
  display: inline-block;
  width: 125px;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
`;

const dateRow = css`
  margin: 10px 0px 10px 0px;
  justify-content: center;
  padding-right: 0px;
  height: auto;
  @media only screen and (min-width: 768px) {
    justify-content: flex-end;
    padding-right: 20px;
  }
`;

const orderText = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-weight: bold;
  color: white;
  text-align: center;
  font-size: 0.9375rem;
  @media only screen and (min-width: 768px) {
    font-size: 18px;
  }
`;

const infoRow = css`
  margin: 10px 0px;
  text-align: center;
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    height: auto;
    align-items: baseline;
    vertical-align: top;
    margin: 25px 0px;
    flex-direction: row;
  }
`;

const buttonRow = css`
  flex-direction: column;
  height: auto;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

const commentsRow = css`
  text-align: center;
  height: auto;
  @media only screen and (min-width: 768px) {
    height: auto;
    text-align: left;
  }
`;

const commentsCol = css`
  align-items: center;
  margin-left: 0px;
  @media only screen and (min-width: 768px) {
    align-items: flex-start;
    margin-left: 50px;
  }
`;

const itemCol = css`
  margin-left: 0px;
  display: block;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    display: flex;
    align-items: flex-start;
    margin: 0px;
    margin-left: 50px;
    margin-bottom: 0px;
  }
`;

const infoCol = css`
  display: block;
  text-align: center;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    align-items: flex-start;
    margin-left: 50px;
    text-align: left;
    margin-bottom: 0px;
  }
`;

const cancelCol = css`
  align-items: center;
  margin: 5px 0px 10px;
  order: 2;
  @media only screen and (min-width: 768px) {
    align-items: flex-start;
    margin: 25px 50px;
    order: 0;
  }
`;

const confirmCol = css`
  align-items: center;
  margin: 15px 0px 5px;
  order: 1;
  @media only screen and (min-width: 768px) {
    align-items: flex-end;
    margin: 25px 50px;
    order: 0;
  }
`;

const orderModal = css`
  bottom: 0;
  left: 0;
  margin: auto;
  max-height: 250px;
  position: fixed;
  right: 0;
  top: 0;
  margin-left: 10px;
  margin-right: 10px;
  width: auto;
  @media only screen and (min-width: 768px) {
    position: fixed;
    z-index: 1300;
    right: 0px;
    bottom: 0px;
    top: 25%;
    left: 0px;
    width: 800px;
    margin: auto;
  }
`;

const cancelledImg = css`
  width: 15%;
  @media only screen and (min-width: 768px) {
    width: 5%;
  }
`;

const cardRejectImg = css`
  width: 20%;
  @media only screen and (min-width: 768px) {
    width: 7%;
  }
`;

const orderImg = css`
  width: 50%;
  @media only screen and (min-width: 768px) {
    width: 25%;
  }
`;

const imgRow = css`
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    margin-bottom: 50px;
  }
`;

const listStyleCustomerInfo = css`
  list-style: none;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-weight: normal;
  font-size: 14px;
  color: black;
`;
const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-weight: normal;
  font-size: 14px;
  color: black;
  margin: "10px";
`;

function OrderCard({
  appId: appId,
  adminUserId: adminUserId,
  cancelOrder,
  requestUpdateOrder,
  transaction: {
    customerAdditionalComments,
    basicUserInfo: { userId, email, phone, firstName, lastName, address },
    id: orderId,
    orderTotal,
    userPurchaseItems,
    orderStatus,
    createdDate: orderDate,
    businessAdditionalComments,
    clientCalculatedSubtotal,
    deliveryType: orderDeliveryType,
    deliveryCost,
    deliveryAddress,
    subtotal,
    totalDiscount,
    totalAmountRefunded,
    customerTip,
  },
}) {
  const getNumberPurchased = (purchaseItem) => {
    const purchaseItemIds = [];
    userPurchaseItems.forEach((item) => {
      // if (orderId === 12053) {
      //   console.log("counting for item");
      //   console.dir(purchaseItem);
      //   console.log("comparing to item");
      //   console.dir(item);
      // }
      if (
        item.purchaseItem.id === purchaseItem.purchaseItem.id &&
        JSON.stringify(item.additionalOptionsItems) ===
          JSON.stringify(purchaseItem.additionalOptionsItems)
      ) {
        purchaseItemIds.push(item.purchaseItem.id);
      }
    });
    return purchaseItemIds.length;
  };

  const purchasedItems = [];

  userPurchaseItems.map((purchaseItem) => {
    const found = find(purchasedItems, {
      purchaseItemId: purchaseItem.purchaseItem.id,
      additionalOptionsItems: purchaseItem.additionalOptionsItems,
    });
    // if (orderId === 12107) {
    //   console.log("printing purchase items");
    //   console.dir(purchaseItem);
    // }

    if (!found) {
      const numberPurchased = getNumberPurchased(purchaseItem);
      const purchaseItemId = purchaseItem.purchaseItem.id;
      // TODO: change price
      const additionalSelectionsByGroup =
        purchaseItem.additionalSelectionsByGroupPretty;
      const purchasePrice = purchaseItem.purchasePrice;
      const itemName = purchaseItem.purchaseItem.title;
      const additionalOptionsItems = purchaseItem.additionalOptionsItems;
      purchasedItems.push({
        numberPurchased,
        purchaseItemId,
        purchasePrice,
        itemName,
        additionalSelectionsByGroup,
        additionalOptionsItems,
      });
    }
  });

  // if (orderId === 12107) {
  //   console.log("printing purchase items");
  //   console.dir(purchasedItems);
  // }

  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [paidNotes, setPaidNotes] = useState(false);
  const [bizNotes, setBizNotes] = useState(businessAdditionalComments);
  const [clientsTotal, setClientsTotal] = useState(clientCalculatedSubtotal);

  var orderToUpdate = {
    userId: userId,
    appId: appId,
    adminUserId: adminUserId,
    businessAdditionalComments: bizNotes,
    orderStatus: orderStatus,
    clientCalculatedSubtotal: clientsTotal,
  };

  const updateOrderField = (field) => (value) => {
    if (field === "clientCalculatedSubtotal") {
      value = formatDollarsToCents(value["value"]);
    }
    setClientsTotal(value);
  };

  const requestUpdateOrderHelper = async () => {
    requestUpdateOrder(orderStatus, orderToUpdate, orderId, paidNotes);
    setPaidNotes(false);
    toggleModal();
  };

  const cancelOrderHelper = async () => {
    cancelOrder(orderId, orderToUpdate);
    toggleCancelModal();
  };

  const toggleModal = () => {
    setShowModal(!showModal);
    setPaidNotes(false);
  };
  const toggleCancelModal = () => {
    setShowCancelModal(!showCancelModal);
    toggleModal();
  };
  const toggleBothModals = () => {
    toggleModal();
    toggleCancelModal();
  };

  const formatDollarsToCents = (value) => {
    value = (value + "").replace(/[^\d.-]/g, "");
    if (value && value.includes(".")) {
      value = value.substring(0, value.indexOf(".") + 3);
    }
    return value ? Math.round(parseFloat(value) * 100) : 0;
  };

  const formatCentsToDollars = (value) => {
    value = (value + "").replace(/[^\d.-]/g, "");
    value = parseFloat(value);
    var returnVal = value ? value / 100 : 0;
    return returnVal.toFixed(2);
  };

  const renderModal = () => {
    if (!showModal) return null;
    return (
      <Modal
        open={showModal}
        // disableAutoFocus={true}
        onClose={showCancelModal ? toggleBothModals : toggleModal}
        className={orderModal}
      >
        <div className={container}>
          <form className={formStyle}>
            {orderStatus === "PLACED" && !showCancelModal && (
              <H2 style={{ marginBottom: "20px" }}>Order Details</H2>
            )}
            {orderStatus === "READY" && !showCancelModal && (
              <H2 style={{ marginBottom: "20px" }}>Order Details</H2>
            )}
            {orderStatus === "CARD_REJECTED" && !showCancelModal && (
              <H2 style={{ marginBottom: "20px" }}>Order Details</H2>
            )}
            {orderStatus === "PAID" && !showCancelModal && paidNotes && (
              <H2 style={{ marginBottom: "20px" }}>
                Update and Send Message to Customer
              </H2>
            )}
            {orderStatus === "PAID" && !showCancelModal && !paidNotes && (
              <H2 style={{ marginBottom: "20px" }}>Fulfill Order</H2>
            )}
            {orderStatus === "PAID" && !showCancelModal && !paidNotes && (
              <H2 style={{ marginBottom: "20px", fontWeight: "normal" }}>
                Are you sure you want to mark this order fulfilled? This cannot
                be undone.
              </H2>
            )}
            {showCancelModal && (
              <H2 style={{ marginBottom: "20px" }}>
                Cancel Order Confirmation
              </H2>
            )}
            {!showCancelModal && !paidNotes && orderStatus != "PAID" && (
              <div style={{ width: "150px" }}>
                <NumberFormat
                  placeholder="Order Total"
                  thousandSeparator={true}
                  prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  defaultValue={
                    subtotal ? formatCentsToDollars(subtotal) : null
                  }
                  onValueChange={updateOrderField("clientCalculatedSubtotal")}
                  className={inputStyle}
                  disabled={orderStatus === "PAID"}
                />
              </div>
            )}
            {showCancelModal && (
              <textarea
                className={TextAreaStyle}
                value={bizNotes}
                placeholder=" Please describe a reason for cancellation."
                onChange={(e) => setBizNotes(e.target.value)}
              />
            )}
            {orderStatus != "PAID" && !showCancelModal && (
              <textarea
                className={TextAreaStyle}
                value={bizNotes}
                placeholder="Business Additional Comments"
                onChange={(e) => setBizNotes(e.target.value)}
              />
            )}
            {orderStatus === "PAID" && !showCancelModal && paidNotes && (
              <textarea
                className={TextAreaStyle}
                value={bizNotes}
                placeholder="Business Additional Comments"
                onChange={(e) => setBizNotes(e.target.value)}
              />
            )}

            <FlexRow style={{ justifyContent: "flex-end", height: "auto" }}>
              <Button
                background="#F17F7F"
                onClick={toggleModal}
                className={boldButton}
              >
                Close
              </Button>

              {orderStatus === "PLACED" && !showCancelModal && (
                <Button
                  background="#89D2D3"
                  onClick={requestUpdateOrderHelper}
                  className={boldButton}
                >
                  Ready!
                </Button>
              )}
              {orderStatus === "READY" && !showCancelModal && (
                <Button
                  background="#89D2D3"
                  onClick={requestUpdateOrderHelper}
                  className={boldButton}
                >
                  Update!
                </Button>
              )}
              {orderStatus === "CARD_REJECTED" && !showCancelModal && (
                <Button
                  background="#89D2D3"
                  onClick={requestUpdateOrderHelper}
                  className={boldButton}
                >
                  Update!
                </Button>
              )}

              {orderStatus === "PAID" && !showCancelModal && (
                <Button
                  background="#89D2D3"
                  onClick={requestUpdateOrderHelper}
                  className={boldButton}
                >
                  Confirm
                </Button>
              )}
              {showCancelModal && (
                <Button
                  background="#89D2D3"
                  onClick={cancelOrderHelper}
                  className={boldButton}
                >
                  Confirm Cancellation
                </Button>
              )}
            </FlexRow>
          </form>
        </div>
      </Modal>
    );
  };

  var fullName = null;
  if (firstName && lastName) {
    fullName = firstName + " " + lastName;
  }

  var totalNumberOfItems = 0;
  purchasedItems.map((purchaseItem) => {
    totalNumberOfItems += purchaseItem.numberPurchased;
  });

  String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const getImgSrc = (orderStatus) => {
    var imgSrc;
    switch (orderStatus) {
      case "PLACED":
        return (imgSrc =
          "https://mobile360-assets.s3.us-east-2.amazonaws.com/order_progress/order_progress_placed.png");
      case "READY":
        return (imgSrc =
          "https://mobile360-assets.s3.us-east-2.amazonaws.com/order_progress/order_progress_ready.png");

      case "PAID":
        return (imgSrc =
          "https://mobile360-assets.s3.us-east-2.amazonaws.com/order_progress/order_progress_paid.png");

      case "FULFILLED":
        return (imgSrc =
          "https://mobile360-assets.s3.us-east-2.amazonaws.com/order_progress/order_progress_fulfilled.png");
      case "CANCELLED":
        return (imgSrc =
          "https://mobile360-assets.s3.us-east-2.amazonaws.com/order_progress/order_progress_cancelled.png");
      case "CARD_REJECTED":
        return (imgSrc =
          "https://mobile360-assets.s3.us-east-2.amazonaws.com/order_progress/order_progress_card_rejected.png");
      default:
        imgSrc = null;
    }
  };

  const padValue = (value) => {
    return value < 10 ? "0" + value : value;
  };

  const formatDate = (dateVal) => {
    var newDate = new Date(dateVal);

    var sMonth = padValue(newDate.getMonth() + 1);
    var sDay = padValue(newDate.getDate());
    var sYear = newDate.getFullYear();
    var sHour = newDate.getHours();
    var sMinute = padValue(newDate.getMinutes());
    var sAMPM = "AM";

    var iHourCheck = parseInt(sHour);

    if (iHourCheck > 12) {
      sAMPM = "PM";
      sHour = iHourCheck - 12;
    } else if (iHourCheck === 0) {
      sHour = "12";
    }

    sHour = padValue(sHour);

    return (
      sMonth +
      "/" +
      sDay +
      "/" +
      sYear +
      " " +
      sHour +
      ":" +
      sMinute +
      " " +
      sAMPM
    );
  };
  const cardRef = useRef();
  var parsedOrderDate = null;
  if (orderDate) {
    parsedOrderDate = formatDate(orderDate);
  }
  const getImgClassName = (orderStatus) => {
    if (orderStatus === "CANCELLED") {
      return cancelledImg;
    } else if (orderStatus === "CARD_REJECTED") {
      return cardRejectImg;
    } else {
      return orderImg;
    }
  };

  const renderAdditionalItems = (additionalSelectionsByGroup) => {
    // console.log(additionalSelectionsByGroup.join("\n"));
    return (
      <div>
        {additionalSelectionsByGroup.map((group) => {
          return (
            <span style={{ color: "rgb(158, 158, 158)" }}>
              {group}
              <br />
            </span>
          );
        })}
      </div>
    );
  };

  return (
    <Form
      padding="0em"
      marginBottom="3em"
      key={orderId}
      className="printElement"
      style={{
        // paddingBottom: "25px",
        boxShadow:
          "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
      }}
      ref={cardRef}
    >
      <FlexRow
        style={{
          backgroundColor: "#89D2D3",
          padding: "20px",
          height: "auto",
        }}
      >
        <FlexColumn>
          <p className={orderText}>
            Order #{orderId}{" "}
            {orderDeliveryType
              ? "(" + orderDeliveryType.toProperCase() + ")"
              : null}
          </p>
        </FlexColumn>

        <ReactToPrint
          pageStyle="
          @media print {
            html, body, div {
              height: initial !important;
              overflow: initial !important;
              -webkit-print-color-adjust: exact;
              page-break-inside: avoid; }}
          @page { size: auto; margin: 10mm;}
        "
          trigger={() => (
            <FontAwesomeIcon
              icon="print"
              style={{ color: "white", cursor: "pointer", fontSize: "21px" }}
            />
          )}
          content={() => cardRef.current}
        />
      </FlexRow>
      {orderDate ? (
        <FlexRow className={dateRow}>
          <P
            style={{
              fontWeight: "bold",
            }}
          >
            {parsedOrderDate}
          </P>
        </FlexRow>
      ) : null}
      {subtotal && deliveryCost ? (
        <FlexRow
          style={{
            height: "auto",
            width: "200px",
            margin: "auto",
          }}
        >
          <FlexColumn
            style={{
              width: "46%",
              alignItems: "flex-start",
              textAlign: "left",
              margin: "0px",
            }}
          >
            <div>
              <P
                style={{
                  fontWeight: "normal",
                  textAlign: "left",
                  color: "#9E9E9E",
                  lineHeight: "25px",
                }}
              >
                Subtotal: <br />
                {orderDeliveryType === "SHIPPING" ? "Shipping " : "Delivery "}
                Fee: <br />
                {totalDiscount !== null && totalDiscount > 0
                  ? "Discount:"
                  : null}{" "}
                {totalDiscount !== null && totalDiscount > 0 && <br />}
                {customerTip !== null && customerTip > 0 ? "Tip:" : null}{" "}
                {customerTip !== null && customerTip > 0 && <br />}
              </P>
              <P
                style={{
                  fontWeight: "bold",
                  marginBottom: "15px",
                  textAlign: "left",
                  marginTop: "7px",
                  fontSize: "0.9375rem",
                }}
              >
                Total:
              </P>
              {totalAmountRefunded !== null && totalAmountRefunded > 0 && (
                <P
                  style={{
                    fontWeight: "normal",
                    textAlign: "left",
                    color: "#9E9E9E",
                    lineHeight: "25px",
                  }}
                >
                  {" "}
                  {totalAmountRefunded !== null && totalAmountRefunded > 0
                    ? "Refunded:"
                    : null}{" "}
                </P>
              )}
            </div>
          </FlexColumn>
          <FlexColumn
            style={{
              width: "54%",
              margin: "0px",
              alignItems: "flex-end",
              textAlign: "right",
            }}
          >
            <div>
              <P
                style={{
                  fontWeight: "normal",
                  textAlign: "right",
                  lineHeight: "25px",
                }}
              >
                {priceToDollars(subtotal)} <br />
                {priceToDollars(deliveryCost)}
                <br />
                {totalDiscount !== null && totalDiscount > 0
                  ? "-" + priceToDollars(totalDiscount)
                  : null}{" "}
                {totalDiscount !== null && totalDiscount > 0 && <br />}
                {customerTip !== null && customerTip > 0
                  ? priceToDollars(customerTip)
                  : null}{" "}
                {customerTip !== null && customerTip > 0 && <br />}
              </P>
              <P
                style={{
                  fontWeight: "bold",
                  marginBottom: "15px",
                  textAlign: "right",
                  marginTop: "7px",
                  fontSize: "0.9375rem",
                }}
              >
                {priceToDollars(orderTotal)}
              </P>
              {totalAmountRefunded !== null && totalAmountRefunded > 0 && (
                <P
                  style={{
                    fontWeight: "normal",
                    textAlign: "right",
                    lineHeight: "25px",
                  }}
                >
                  {" "}
                  {totalAmountRefunded !== null && totalAmountRefunded > 0
                    ? priceToDollars(totalAmountRefunded)
                    : null}{" "}
                </P>
              )}
            </div>
          </FlexColumn>
        </FlexRow>
      ) : null}
      {subtotal && !deliveryCost && !totalDiscount && !totalAmountRefunded ? (
        <FlexRow style={{ height: "auto" }}>
          <FlexColumn>
            <P
              style={{
                fontWeight: "bold",
                marginBottom: "15px",
                fontSize: "0.9375rem",
              }}
            >
              Total: {priceToDollars(subtotal)}
            </P>
          </FlexColumn>
        </FlexRow>
      ) : null}
      {subtotal && !deliveryCost && totalDiscount ? (
        <FlexRow
          style={{
            height: "auto",
            width: "200px",
            margin: "auto",
          }}
        >
          <FlexColumn
            style={{
              width: "46%",
              alignItems: "flex-start",
              textAlign: "left",
              margin: "0px",
            }}
          >
            <P
              style={{
                fontWeight: "normal",
                textAlign: "left",
                color: "#9E9E9E",
                lineHeight: "25px",
              }}
            >
              Subtotal:
              <br />
              {totalDiscount !== null && totalDiscount > 0
                ? "Discount:"
                : null}{" "}
              {customerTip !== null && customerTip > 0 ? "Tip:" : null}{" "}
            </P>
            <P
              style={{
                fontWeight: "bold",
                marginBottom: "15px",
                textAlign: "left",
                marginTop: "7px",
                fontSize: "0.9375rem",
              }}
            >
              Total:
            </P>
          </FlexColumn>
          <FlexColumn
            style={{
              width: "54%",
              margin: "0px",
              alignItems: "flex-end",
              textAlign: "right",
            }}
          >
            <div>
              <P
                style={{
                  fontWeight: "normal",
                  textAlign: "right",
                  lineHeight: "25px",
                }}
              >
                {priceToDollars(subtotal)}
                <br />
                {totalDiscount !== null && totalDiscount > 0
                  ? "-" + priceToDollars(totalDiscount)
                  : null}{" "}
                {totalDiscount !== null && totalDiscount > 0 && <br />}
                {customerTip !== null && customerTip > 0
                  ? priceToDollars(customerTip)
                  : null}{" "}
                {customerTip !== null && customerTip > 0 && <br />}
              </P>
              <P
                style={{
                  fontWeight: "bold",
                  marginBottom: "15px",
                  textAlign: "right",
                  marginTop: "7px",
                  fontSize: "0.9375rem",
                }}
              >
                {priceToDollars(orderTotal)}
              </P>
            </div>
          </FlexColumn>
        </FlexRow>
      ) : null}
      {!subtotal && !deliveryCost ? (
        <FlexRow style={{ height: "auto" }}>
          <FlexColumn>
            <P
              style={{
                fontWeight: "bold",
                marginBottom: "15px",
                fontSize: "0.9375rem",
              }}
            >
              {totalDiscount !== null && totalDiscount > 0
                ? "-" + priceToDollars(totalDiscount)
                : null}{" "}
              {totalDiscount !== null && totalDiscount > 0 && <br />}
              {customerTip !== null && customerTip > 0
                ? priceToDollars(customerTip)
                : null}{" "}
              {customerTip !== null && customerTip > 0 && <br />}
              Total: {priceToDollars(orderTotal)}
            </P>
          </FlexColumn>
        </FlexRow>
      ) : null}
      <FlexRow
        style={{
          height: "auto",
        }}
        className={imgRow}
      >
        <FlexColumn>
          {orderStatus ? (
            <img
              style={{
                margin: "10px",
              }}
              className={getImgClassName(orderStatus)}
              src={getImgSrc(orderStatus)}
            />
          ) : null}
        </FlexColumn>
      </FlexRow>
      <FlexRow
        className={infoRow}
        style={{ display: "flex", alignItems: "flex-start" }}
      >
        <FlexColumn
          className={itemCol}
          // className={infoCol}
          style={{ height: "inherit" }}
        >
          {totalNumberOfItems ? (
            <P>Items ({totalNumberOfItems}): </P>
          ) : (
            <P>Items: </P>
          )}
          <ul className={listStyleItems}>
            {purchasedItems.map((purchaseItem) => {
              var itemPriceInDollars = null;
              if (purchaseItem.purchasePrice != 0) {
                var itemPriceInDollars = purchaseItem.purchasePrice / 100;
                itemPriceInDollars = itemPriceInDollars.toLocaleString(
                  "en-US",
                  {
                    style: "currency",
                    currency: "USD",
                  }
                );
              }

              return (
                <div
                  key={
                    purchaseItem.purchaseItemId
                      ? purchaseItem.purchaseItemId
                      : Math.floor(Math.random() * Math.floor(100000))
                  }
                  style={{ marginTop: "5px" }}
                >
                  {itemPriceInDollars && purchaseItem.numberPurchased ? (
                    <li>
                      {purchaseItem.numberPurchased} x {purchaseItem.itemName} (
                      {itemPriceInDollars} each)
                    </li>
                  ) : null}
                  {itemPriceInDollars && !purchaseItem.numberPurchased ? (
                    <li>{purchaseItem.itemName}</li>
                  ) : null}
                  {!itemPriceInDollars && purchaseItem.numberPurchased ? (
                    <li>
                      {purchaseItem.numberPurchased} x {purchaseItem.itemName}
                    </li>
                  ) : null}

                  {purchaseItem.additionalSelectionsByGroup &&
                    renderAdditionalItems(
                      purchaseItem.additionalSelectionsByGroup
                    )}
                </div>
              );
            })}
          </ul>
        </FlexColumn>
        <FlexColumn
          className={infoCol}
          style={{ height: "inherit", margin: "0px" }}
        >
          <P
            style={{
              marginLeft: "0px",
            }}
          >
            Customer Information:
          </P>
          <ul className={listStyleCustomerInfo}>
            <li>{fullName ? fullName : null}</li>
            <li>{phone ? phone : null}</li>
            <li>{email ? email : null}</li>
            <li>{address ? address : null}</li>
          </ul>
        </FlexColumn>
        {deliveryAddress ? (
          <FlexColumn
            className={infoCol}
            style={{ height: "inherit", margin: "0px" }}
          >
            <P
              style={{
                marginLeft: "0px",
              }}
            >
              {orderDeliveryType === "SHIPPING" ? "Shipping " : "Delivery "}
              Information:
            </P>
            <ul className={listStyleCustomerInfo}>
              <li>
                {deliveryAddress.streetAddress
                  ? deliveryAddress.streetAddress
                  : null}
              </li>
              <li>
                {deliveryAddress.city ? deliveryAddress.city : null},{" "}
                {deliveryAddress.state ? deliveryAddress.state : null}
              </li>
              <li>{deliveryAddress.zip ? deliveryAddress.zip : null}</li>
            </ul>
          </FlexColumn>
        ) : null}
      </FlexRow>
      {customerAdditionalComments ? (
        <FlexRow className={commentsRow}>
          <FlexColumn className={commentsCol}>
            <P>
              Customer Notes: <br />
              {customerAdditionalComments ? customerAdditionalComments : null}
            </P>
          </FlexColumn>
        </FlexRow>
      ) : null}

      <FlexRow className={buttonRow}>
        <FlexColumn className={cancelCol}>
          {orderStatus === "PLACED" && (
            <Button
              background="#F17F7F"
              onClick={toggleCancelModal}
              className={boldButton}
            >
              Cancel Order
            </Button>
          )}

          {(orderStatus === "READY" || orderStatus === "CARD_REJECTED") && (
            <Button
              background="#F17F7F"
              onClick={toggleCancelModal}
              className={boldButton}
            >
              Cancel Order
            </Button>
          )}

          {orderStatus === "PAID" && (
            <Button
              background="#89D2D3"
              onClick={toggleModal}
              onClick={() => {
                toggleModal();
                setPaidNotes(true);
              }}
              className={boldButton}
              style={{ width: "180px" }}
            >
              Message Customer
            </Button>
          )}

          {/* {orderStatus === "PAID" && (
          <Button
            background="#F17F7F"
            // onClick={deleteDeal}
            className={boldButton}
          >
            Refund
          </Button>
        )} */}
        </FlexColumn>
        <FlexColumn className={confirmCol}>
          {/* Placed is actually recieved on the ui tab */}
          {orderStatus === "PLACED" && (
            <Button
              background="#89D2D3"
              onClick={toggleModal}
              className={boldButton}
              style={{ width: "165px" }}
            >
              Order Prepared
            </Button>
          )}
          {(orderStatus === "READY" || orderStatus === "CARD_REJECTED") && (
            <Button
              background="#89D2D3"
              onClick={toggleModal}
              className={boldButton}
              style={{ width: "165px" }}
            >
              Update Order Info
            </Button>
          )}
          {orderStatus === "PAID" && (
            <Button
              background="#89D2D3"
              onClick={toggleModal}
              className={boldButton}
              style={{ width: "165px" }}
            >
              Order Fulfilled
            </Button>
          )}
          {/* {orderStatus === "FULFILLED" && (
            <Button
              background="#89D2D3"
              // onClick={putDeal}
              className={boldButton}
            >
              Show Refund
            </Button>
          )} */}
        </FlexColumn>
      </FlexRow>
      {renderModal()}
    </Form>
  );
}

export default OrderCard;
